module.exports = __webpack_public_path__ + "static/media/research-bg-ma.556e0874.jpg";